import axios from "axios";

import {
  API_URL
} from "./config/api";

const LOCAL_API_URL =
  "http://localhost:5000";

axios.interceptors.request.use(

  (config) => {

    const isLocalFrontend =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

if (
  !isLocalFrontend &&
  typeof config.url === "string" &&
  config.url.startsWith(
    LOCAL_API_URL
  )
) {

  config.url =
    `${API_URL}${
      config.url.slice(
        LOCAL_API_URL.length
      )
    }`;

}

    const token =
      localStorage.getItem("adminToken");

    if (token) {

      config.headers =
        config.headers || {};

      config.headers.Authorization =
        `Bearer ${token}`;

    }

    return config;

  },

  (error) => Promise.reject(error)

);

axios.interceptors.response.use(

  (response) => response,

  (error) => {

    if (
      error.response?.status === 401
    ) {

      const requestUrl =
        error.config?.url || "";

      const isLoginRequest =
        typeof requestUrl === "string" &&
        requestUrl.endsWith(
          "/api/admin/login"
        );

      if (!isLoginRequest) {

        localStorage.removeItem(
          "adminToken"
        );

        localStorage.removeItem(
          "isAdmin"
        );

        if (
          window.location.pathname
            .startsWith("/admin")
        ) {
          window.location.replace(
            "/login"
          );
        }

      }

    }

    return Promise.reject(error);

  }

);